<section class="contact-top">
    
            <div class="inner_sec">
                <div class="container">
                  <h2>Indirect Capabilities.</h2>
                </div>
                 
            <div class="tabbing_sec">
                <mat-tab-group>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <div class="container">  
                          <lucide-icon name="hammer" class="icon"></lucide-icon>
                           Capabilities
                         </div>
                      </ng-template>
                   
                      
                      <div class="product_list">
                        <div class="container">
                        <h3>Strategies & Framework</h3>
                         <ul class="top_list number">
                            <li *ngFor="let data of materialExpertise"> 
                                <div [innerHTML]="data.item"></div>
                            </li>
                        </ul>
                       </div>

                      </div>


                      <div class="product_list">
                       
                        <div class="product_box map_container"> 
                          
                        <div class="container">
                            <h3>Geographical Footprint</h3>
                          <div class="">
                            <div class="map">
                                <img _ngcontent-ng-c2015405704="" src="../../../../assets/images/worldMap.png" alt="Map">
                            </div>
                            <ul class="statics">
                                <li *ngFor="let data of static"> 
                                    <div [innerHTML]="data.item"></div>
                                </li>
                            </ul>
                          </div>
                        </div>

                         </div>
                        
                        
                      </div>


                      <div class="product_list contract_modal">
                        <div class="container">
                        <h3>Contract Model</h3>
                        <ul class="top_list three_column">
                            <li *ngFor="let data of contract"> 
                                <lucide-icon name="ArrowRight" class="icon" [size]="18"></lucide-icon> {{data.item}}
                            </li>
                        </ul>
                       </div>
                      </div>


                      <div class="product_list bottom_sec">
                        <div class="container">
                        <h3>Benefits</h3>
                        <ul class="top_list three_column">
                            <li *ngFor="let data of benefit"> 
                                 <lucide-icon [name]="data.icon" class="icon" [size]="22"></lucide-icon>
                                 <span [innerHTML]="sanitizeHtml(data.item)"></span>
                            </li>
                        </ul>
                       </div>
                      </div>

                    </mat-tab>
                    <mat-tab>
                      <ng-template mat-tab-label>
                        <lucide-icon name="PackageOpen" class="icon"></lucide-icon>
                        Products
                      </ng-template>
                      
                     <div class="container">
                       <div class="product_list">
                        <div class="product_box">
                            <h3>Safety PPEs</h3>
                            <div class="row">   
                                <div class="col-sm-4" *ngFor="let data of safetyppes">
                                    <div class="productItem">
                                        <figure> <img class="about-img" [src]="data.img" alt=""> </figure>
                                        <h4>{{data.title}}</h4>
                                        <p>{{data.description}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                       </div>

                       <div class="product_list">
                        <div class="product_box mro">
                            <h3>MRO(Maintenance, Repair & Operations)</h3>
                            <div class="row">   
                                <div class="col-sm-6" *ngFor="let data of Mro">
                                    <div class="productItem">
                                        <h4>{{data.title}}</h4>
                                        <div class="row">
                                          <div class="col-sm-6" *ngFor="let item of data.content">
                                            <figure>
                                              <img class="about-img" [src]="item.img" alt="">
                                            </figure>
                                            <p>{{item.description}}</p>
                                          </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                       </div>

                       <div class="product_list">
                        <div class="product_box">
                            <h3>Chemicals & Synthetic Paints</h3>
                            <div class="row">   
                                <div class="col-sm-3" *ngFor="let data of chemical">
                                    <div class="productItem">
                                        <figure> <img class="about-img" [src]="data.img" alt=""> </figure>
                                        <h4>{{data.title}}</h4>
                                        <p>{{data.description}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                       </div>

                       <div class="product_list">
                        <div class="product_box">
                            <h3>Packaging</h3>
                            <div class="row">   
                                <div class="col-sm-3" *ngFor="let data of packaging">
                                    <div class="productItem">
                                        <figure> <img class="about-img" [src]="data.img" alt=""> </figure>
                                        <h4>{{data.title}}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                       </div>

                       <div class="product_list">
                        <div class="product_box">
                            <h3>Furniture ,Equipment's & Stationary Items</h3>
                            <div class="row">   
                                <div class="col-sm-4" *ngFor="let data of furniture">
                                    <div class="productItem">
                                        <figure> <img class="about-img" [src]="data.img" alt=""> </figure>
                                        <h4>{{data.title}}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                       </div>

                       <div class="product_list">
                        <div class="product_box">
                            <h3>Hardware & House Keeping</h3>
                            <div class="row">   
                                <div class="col-sm-4" *ngFor="let data of hardware">
                                    <div class="productItem">
                                        <figure> <img class="about-img" [src]="data.img" alt=""> </figure>
                                        <h4>{{data.title}}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                       </div>
                     </div>

                    </mat-tab>
                </mat-tab-group>
            </div>

            </div>
    
</section>

